function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.63984 0.839966C3.00031 0.839966 0.839844 3.00043 0.839844 5.63997V36.36C0.839844 38.9995 3.00031 41.16 5.63984 41.16H36.3598C38.9994 41.16 41.1598 38.9995 41.1598 36.36V5.63997C41.1598 3.00043 38.9994 0.839966 36.3598 0.839966H5.63984ZM5.63984 2.75997H36.3598C37.9616 2.75997 39.2398 4.03822 39.2398 5.63997V36.36C39.2398 37.9617 37.9616 39.24 36.3598 39.24H5.63984C4.0381 39.24 2.75984 37.9617 2.75984 36.36V5.63997C2.75984 4.03822 4.0381 2.75997 5.63984 2.75997ZM13.3198 8.72809V33.2718L14.7805 32.3793L33.4011 21L13.3198 8.72809ZM15.2398 12.1518L29.7186 21L15.2398 29.8481V12.1518Z",
  fill: "#484848"
});

var SvgIcoYoutube1C = function SvgIcoYoutube1C(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoYoutube1C, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico_youtube_1c.bc570821.svg";
export { ForwardRef as ReactComponent };